import React from 'react';
import { Button } from 'react-bootstrap';
import { isArray } from 'lodash';
import { SellerContact } from '../../../../../structures/models/seller';
import EmailLink from '../../../../partials/EmailLink';
import PhoneNumber from '../../../../search/admin-dashboard-tables/assets/PhoneNumber';

type ContactLineProps = {
  contact: SellerContact,
  onEdit: (value: SellerContact | undefined) => void,
  onDelete?: (value: SellerContact) => void,
  onSetPrimary?: (value: SellerContact) => void,
  currentlyEditing: SellerContact | undefined,
  isLoading?: boolean,
  isPrimary?: boolean,
};

const ContactLine: React.FC<ContactLineProps> = ({
  contact,
  onEdit,
  onDelete,
  onSetPrimary,
  currentlyEditing,
  isLoading,
  isPrimary,
}) => {
  const isEditing = contact === currentlyEditing;
  const {
    name,
    email,
    phone,
    phone_extn,
    contact_preference,
    alternate_phone,
    alternate_phone_extn,
    contact_preference_alternate,
    best_time_to_call,
  } = contact;

  return (
    <tr className="small-txt">
      <td>{name}</td>
      <td><EmailLink email={email} /></td>
      <td>
        <PhoneNumber
          phone={phone}
          phone_extn={phone_extn}
          linkClassName="text-table-light-gray m-0"
          textClassName="text-table-light-gray m-0"
        />
        {(isArray(contact_preference) && contact_preference.length > 0) ? (
          <p className="m-0 text-capitalize">
            {contact_preference.join(', ')}
          </p>
        ) : (
          <></>
        )}
      </td>
      <td>
        <PhoneNumber
          phone={alternate_phone}
          phone_extn={alternate_phone_extn}
          linkClassName="text-table-light-gray m-0"
          textClassName="text-table-light-gray m-0"
        />
        {(isArray(contact_preference_alternate) && contact_preference_alternate.length > 0) ? (
          <p className="m-0 text-capitalize">{contact_preference_alternate.join(', ')}</p>
        ) : (
          <></>
        )}
      </td>
      <td>{best_time_to_call}</td>
      <td>
        {!isPrimary
          ? (
            onSetPrimary
            && (
              <Button
                type="button"
                size="sm"
                variant="outline-primary"
                onClick={() => onSetPrimary(contact)}
                disabled={isLoading}
                className="py-1 px-3 border-radius-50 text-nowrap"
              >
                Set Primary
              </Button>
            )
          )
          : <>Yes</>}
      </td>
      <td>
        {!isEditing
          && (
            <Button
              type="button"
              size="sm"
              variant="primary"
              onClick={() => onEdit(contact)}
              disabled={isLoading}
              className="py-1 px-3 border-radius-50 text-nowrap"
            >
              Edit
            </Button>
          )}
      </td>
      <td>
        {!isPrimary && onDelete
          && (
            <Button
              type="button"
              size="sm"
              variant="outline-danger"
              onClick={() => onDelete(contact)}
              disabled={isLoading}
              className="py-1 px-3 border-radius-50 text-nowrap"
            >
              Delete
            </Button>
          )}
      </td>
    </tr>
  );
};

export default ContactLine;
